import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { initSyncManager, cleanupSyncManager } from "@/lib/sync-manager";
import { useAuthConditional } from "@/lib/use-auth-conditional";
import { CLERK_AVAILABLE } from "@/lib/auth";

/**
 * Provider component that initializes the sync manager with auth context
 * Should be placed inside auth providers but outside router
 */
export function SyncManagerProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuthConditional();
  const queryClient = useQueryClient();

  useEffect(() => {
    // Initialize sync manager with token function and query client
    const getToken = async (): Promise<string | null> => {
      if (CLERK_AVAILABLE && auth.getToken) {
        return auth.getToken();
      }
      return null;
    };

    initSyncManager(getToken, queryClient);

    return () => {
      cleanupSyncManager();
    };
  }, [auth.getToken, queryClient]);

  return <>{children}</>;
}
